module.exports = __webpack_public_path__ + "img/port_centrion_linuxti.db7a33aa.png";